<template>
  <div class="poster">
    <img class="title" :src="titleTopImg" />
    <slot></slot>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import openApp from '../../../../utils/openApp'
import { getBase64Img } from '../../../../utils/getBase64Image'
const titleTop = require('../../../../assets/images/title_top.png')

export default {
  name: 'BasicPoster',
  computed: {
    ...mapGetters('activityInfo', ['activityId','activityInfo']),
    ...mapGetters('userInfo', ['userInfo']),
    ...mapGetters(['systemInfo'])
  },
  data() {
    return {
      titleTopImg: ''
    }
  },
  created() {
    this.initUserInfo()
  },
  methods: {
    async initUserInfo() {
      let url = window.location.origin + window.location.pathname + titleTop
      if (process.env.VUE_APP_RUN_ENV === 'dev') {
        url = 'https://teststatic.nfapp.southcn.com/hd/gd-red-map/img/title_top.d70c6fd4.png'
      }
      if (this.activityInfo.mapStyle && this.activityInfo.mapStyle.material && this.activityInfo.mapStyle.material.titleUrl) {
        url = this.activityInfo.mapStyle.material.titleUrl
      }
      this.titleTopImg = await getBase64Img(url)
      if (this.$route.query.rid) {
        this.$emit('initializedUser')
        return
      }
      if (this.systemInfo.isWx || this.systemInfo.isNfPlus) {
        if (!this.userInfo.userUuid) {
          await this.$store.dispatch('userInfo/getUserInfo')
        }
        if (!this.userInfo.userUuid && this.systemInfo.isNfPlus) {
          await this.$store.dispatch('userInfo/getNfplusUserByLogin')
        }
        this.$emit('initializedUser')
      } else {
        openApp(
          {
            address:
              window.location.origin +
              window.location.pathname +
              this.$router.resolve({
                path: '/',
                query: { id: this.activityId }
              }).href
          },
          this.activityId,
          39
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.poster {
  position: absolute;
  top: -9999px;
  left: -9999px;
  z-index: -1;
  width: 6.8rem;
  min-height: 7.3rem;
  margin: 0 auto;
  box-sizing: border-box;
  background-color: #ffdab4;
  //border-radius: 0.2rem;
  font-size: 0;
  text-align: center;
  overflow: hidden;

  .title {
    width: 6.2rem;
    margin-top: 0.34rem;
  }
}
</style>
